// extracted by mini-css-extract-plugin
export default {"container":"ActivityModal_container__AtK+F"};